import React from "react";
import {css, cx} from "emotion";

const CustomSelectComponent = ({replacementText, styleName, extraClasses, getStyles, innerProps, innerRef, children, ...props}) => (
    <div className={cx(css(getStyles(styleName, props))) + ` ${extraClasses}`} {...innerProps}>{replacementText || children}</div>
);

export default CustomSelectComponent;